import React from 'react'
import styled from 'styled-components'
import theme from '../../styles/theme'
import { FormattedHTMLMessage } from 'react-intl'
import RightWrong from '../RightWrong'
const { colors } = theme

const Button = props => {
  return (
    <StyledButton
      id={props.id}
      ref={props.reference}
      type={props.type}
      icon={props.icon}
      image={props.image}
      className={props.classes}
      disabled={props.disabled}
      onClick={props.handleClick}
      isCorrect={props.isCorrect}
      data-iscorrect={props.isCorrect}
      data-responsetext={props.responseText}
      data-value={props.value}
      data-currentorder={props.currentorder}
      data-order={props.order}
      alignSelf={props.alignSelf}
      tabIndex={props.tabIndex}
    >
      {props.icon && <RightWrong isRight={props.isCorrect} clicked={props.clicked} />}
      {props.text && (
        <FormattedHTMLMessage id={props.text} />
      )}
      {props.placeholder}
    </StyledButton>
  )
}

const StyledButton = styled.button`
  align-self: ${({ alignSelf }) => alignSelf || ''};
  border: none;
  border-radius: 0.60rem;
  padding: 0.65rem 1rem;
  text-decoration: none;
  font-size: 1.5em;
  cursor: pointer;
  transition: background 250ms ease-in-out, transform 150ms ease;
  -webkit-appearance: none;
  -moz-appearance: none;
  color: ${_ => colors.fontColor};
  display: flex;
  align-items: center;
  nav > & {
    padding-left: 1.5em;
    padding-right: 1.5em;
  }
  
  &.continue, &.skip {
    color:  #fdfdfd;
    background: transparent;
    border: 1px solid white;
    border-radius: 0.05rem;
    transition: all 1s cubic-bezier(0.075, 0.82, 0.165, 1);
    &:hover, &:focus {
      span {
        color: ${_ => colors.background};
      }
      background: ${_ => colors.fontColor};
    }
  }
  &.mc-option {
    border-radius: 0.05rem;
    text-align: left;
    padding: 1rem 1rem 1rem 0;
    span {
      color: #000;
    }
    &:hover {
      filter:brightness(0.9);
    }
    background: #fdfdfd;
  }
  &.clicked {
    background:${({ isCorrect }) => colors[isCorrect ? 'right' : 'wrong']};
    path {
      opacity: 1;
    }
    span { 
      color: white;
      border-color: white!important;
    }
  }
  &.menu-button {
    color: #303133;
    justify-content: center;
  }
  &.option {
    color: #303133;
    text-align: left;
    padding-right: 2em;
    padding-left: 1em;
  }

  &.disabled {
    opacity: 0.3;
  }
  &:disabled {
    cursor: default;
    opacity: 0.3;
  }
  &.correct {
    text-decoration: none;
    background-image: url('images/icons/right.svg');
    background-position: top 0.5em right 0.5em;
    background-size: 1.1em 1.1em;
    background-repeat: no-repeat;
  }
  &.wrong {
    text-decoration: line-through;
    background-image: url('images/icons/wrong.svg');
    background-position: top 0.5em right 0.5em;
    background-size: 1.1em 1.1em;
    background-repeat: no-repeat;
  }
  &.images {
    background-image: url(${props => props.image});
    background-position: center right;
    background-size: cover;
    background-repeat: no-repeat;
    width: calc(50% - 1.5em);
    max-width: 15em;
    min-width: 0px;
    height: 0;
    padding: 0;
    padding-top: calc(50% - 1.5em);
    overflow: hidden;
    margin-bottom: 1em;
    :nth-child(odd) {
      margin-right: 0.5em;
    }
    :nth-child(even) {
      margin-left: 0.5em;
    }
  }
`

export default Button

/*
  &.hidden {
    visibility: hidden;
  }
*/
